import { render, staticRenderFns } from "./VHtmlEditor.vue?vue&type=template&id=13e228ee&scoped=true"
import script from "./VHtmlEditor.vue?vue&type=script&lang=js"
export * from "./VHtmlEditor.vue?vue&type=script&lang=js"
import style0 from "./VHtmlEditor.vue?vue&type=style&index=0&id=13e228ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e228ee",
  null
  
)

export default component.exports